var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3974_2678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3974_2678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30775 21.5C4.80908 21.5 4.38308 21.3234 4.02975 20.9703C3.67658 20.6169 3.5 20.1909 3.5 19.6923V8.49425C3.2065 8.34292 2.96642 8.12783 2.77975 7.849C2.59325 7.57017 2.5 7.24867 2.5 6.8845V4.30775C2.5 3.80908 2.67658 3.38308 3.02975 3.02975C3.38308 2.67658 3.80908 2.5 4.30775 2.5H19.6923C20.1909 2.5 20.6169 2.67658 20.9703 3.02975C21.3234 3.38308 21.5 3.80908 21.5 4.30775V6.8845C21.5 7.24867 21.4068 7.57017 21.2203 7.849C21.0336 8.12783 20.7935 8.34292 20.5 8.49425V19.6923C20.5 20.1909 20.3234 20.6169 19.9703 20.9703C19.6169 21.3234 19.1909 21.5 18.6923 21.5H5.30775ZM5 8.69225V19.6443C5 19.7468 5.03683 19.8317 5.1105 19.899C5.18433 19.9663 5.27575 20 5.38475 20H18.6923C18.7821 20 18.8558 19.9712 18.9135 19.9135C18.9712 19.8558 19 19.7821 19 19.6923V8.69225H5ZM4.30775 7.19225H19.6923C19.7821 7.19225 19.8558 7.16342 19.9135 7.10575C19.9712 7.04808 20 6.97433 20 6.8845V4.30775C20 4.21792 19.9712 4.14417 19.9135 4.0865C19.8558 4.02883 19.7821 4 19.6923 4H4.30775C4.21792 4 4.14417 4.02883 4.0865 4.0865C4.02883 4.14417 4 4.21792 4 4.30775V6.8845C4 6.97433 4.02883 7.04808 4.0865 7.10575C4.14417 7.16342 4.21792 7.19225 4.30775 7.19225ZM9.19225 13.4327H14.8077V12H9.19225V13.4327Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcn);
export default __webpack_public_path__ + "static/media/productIcn.dab0b047c9812f916e798300ad2e3329.svg";
export { ForwardRef as ReactComponent };